export const VsebinaZaOdrasleGesloEnum = {
  GESLO_PROGRAMI_ZA_ODRASLE: '601639'
}



// WEBPACK FOOTER //
// ./src/assets/js/Enum/VsebinaZaOdrasleGesloEnum.js